import { ErrorBoundary } from 'react-error-boundary'
import { useRouter } from 'next/router'

import InfoTerkiniDetailApp from 'app/InfoTerkiniDetailPage/pages/InfoTerkiniDetail'
import { isToggleEnabled } from 'configs/toggle-feature'
import { CustomErrorFallback } from 'components/ErrorBoundary'

export async function getServerSideProps({ params }) {
  const isInfoTerkiniEnabled = await isToggleEnabled(
    'aum-ce-info-terkini-enabled'
  )

  return {
    props: {
      isInfoTerkiniEnabled,
      id: params.id,
    },
  }
}

export interface InfoTerkiniDetailProps {
  isInfoTerkiniEnabled: boolean
  id: string
}

const InfoTerkiniDetailPage = (props: InfoTerkiniDetailProps) => {
  const router = useRouter()

  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => {
        return (
          <CustomErrorFallback
            error={error}
            resetErrorBoundary={resetErrorBoundary}
          />
        )
      }}
    >
      <InfoTerkiniDetailApp {...props} />
    </ErrorBoundary>
  )
}

export default InfoTerkiniDetailPage
